import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveApiErrorMessage } from 'app/api/app-api/apiHooksHelpers';
import PageHeader from "../core/App/PageHeader";
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Text, Heading as TombacHeading, tombac } from 'tombac';
import { useUnsubscribeCommunicationEmailMutation } from "./communicationsApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const EmailUnsubscribePage = () => {
  const location = useLocation();
  const {
    error: unsubscribeError,
    isLoading,
    mutateAsync: unsubscribe
  } = useUnsubscribeCommunicationEmailMutation();
  const [error, setError] = useState(null);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const data = searchParams.get('data') || '';
    const sign = searchParams.get('sign') || '';
    if (!data || !sign) {
      setError('Invalid unsubscribe link');
      return;
    }
    unsubscribe({
      data,
      sign
    });
  }, [unsubscribe]);
  useEffect(() => {
    if (unsubscribeError) {
      resolveApiErrorMessage(unsubscribeError).then(message => {
        setError(message);
      });
    }
  }, [unsubscribeError]);
  return /*#__PURE__*/_jsx(PageHeader, {
    $display: "flex",
    $justifyContent: "center",
    $pb: "5sp",
    "data-sentry-element": "PageHeader",
    "data-sentry-component": "EmailUnsubscribePage",
    "data-sentry-source-file": "EmailUnsubscribePage.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      $width: "680u",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "EmailUnsubscribePage.tsx",
      "data-sentry-element": "Box",
      children: isLoading ? /*#__PURE__*/_jsx(Heading, {
        level: 1,
        children: "Unsubscribing..."
      }) : error ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 1,
          children: "Unsubscribe failed"
        }), /*#__PURE__*/_jsx(Message, {
          children: "There was an error while trying to unsubscribe. Please try again later or contact support."
        }), /*#__PURE__*/_jsxs(Text, {
          $m: "0 auto 2sp",
          $maxWidth: "100%",
          $width: "max-content",
          as: "details",
          children: [/*#__PURE__*/_jsx("summary", {
            children: "Error details"
          }), /*#__PURE__*/_jsx("code", {
            children: error
          })]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 1,
          children: "Unsubscribe successful"
        }), /*#__PURE__*/_jsxs(Message, {
          children: ["You have successfully unsubscribed from email notifications about new release notes. If this was a mistake, you can resubscribe in your", ' ', /*#__PURE__*/_jsx(Text, {
            $display: "inline",
            as: Link,
            fontSize: 24,
            to: "/settings",
            variant: "interactive",
            children: "account settings"
          }), "."]
        })]
      })
    })
  });
};
const Heading = styled(TombacHeading).withConfig({
  displayName: "EmailUnsubscribePage__Heading"
})(["text-align:center;"]);
const Message = styled.p.withConfig({
  displayName: "EmailUnsubscribePage__Message"
})(["", " text-align:center;"], tombac.text({
  color: tombac.color('neutral', 700),
  fontSize: 24
}));